module.exports = __webpack_public_path__ + "static/media/h1.4a0a5074.svg";